import { render, staticRenderFns } from "./coalqr.vue?vue&type=template&id=b01c2050&scoped=true"
import script from "./coalqr.vue?vue&type=script&lang=js"
export * from "./coalqr.vue?vue&type=script&lang=js"
import style0 from "./coalqr.vue?vue&type=style&index=0&id=b01c2050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01c2050",
  null
  
)

export default component.exports